// import React, { useEffect, useState } from 'react';
// import {
//   adminGetMembers, adminGetCases, adminUpdateMemberStatus, adminUpdateCaseStatus, adminRenewMember,
//   adminGetContent, adminCreateContent, adminUpdateContent, adminDeleteContent,
//   adminGetMessages, adminReplyToMember,
//   adminGetAppointments, adminUpdateAppointmentStatus,
//   adminGetComplaints, adminUpdateComplaintStatus,
//   adminGetVolunteers, adminUpdateVolunteerStatus,
// } from '../../services/api';

// const MEMBER_STATUSES = ['PENDING', 'ACTIVE', 'EXPIRED', 'SUSPENDED'];
// const CASE_STATUSES = [
//   'CASE_RECEIVED', 'CASE_REVIEW_COMPLETED', 'DOCUMENTS_PREPARED',
//   'SUBMITTED', 'AWAITING_OUTCOME', 'FINALISED',
// ];
// const APPOINTMENT_STATUSES = ['PENDING', 'CONFIRMED', 'CANCELLED', 'COMPLETED'];
// const APPLICATION_STATUSES = ['SUBMITTED', 'UNDER_REVIEW', 'APPROVED', 'REJECTED'];
// const CONTENT_CATEGORIES = [
//   { value: 'NEWS', label: 'News & Announcements' },
//   { value: 'PODCAST', label: 'Podcast Episode' },
//   { value: 'RIGHTS_LIBRARY', label: "Rights Library Article" },
//   { value: 'CASE_STORY', label: 'Real Case Story' },
// ];

// const emptyContentForm = { title: '', content: '', category: 'NEWS', mediaUrl: '' };

// const th = { padding: 10 };
// const td = { padding: 10 };
// const row = { borderBottom: '1px solid #f0f0f0' };

// export default function AdminDashboard() {
//   const [tab, setTab] = useState('members');

//   const [members, setMembers] = useState([]);
//   const [cases, setCases] = useState([]);
//   const [content, setContent] = useState([]);
//   const [messages, setMessages] = useState([]);
//   const [appointments, setAppointments] = useState([]);
//   const [complaints, setComplaints] = useState([]);
//   const [volunteers, setVolunteers] = useState([]);

//   const [contentForm, setContentForm] = useState(emptyContentForm);
//   const [editingId, setEditingId] = useState(null);
//   const [savingContent, setSavingContent] = useState(false);
//   const [renewingId, setRenewingId] = useState(null);

//   const [replyMemberId, setReplyMemberId] = useState('');
//   const [replyContent, setReplyContent] = useState('');
//   const [sendingReply, setSendingReply] = useState(false);

//   const loadMembers = () => adminGetMembers().then((res) => setMembers(res.data)).catch(() => {});
//   const loadCases = () => adminGetCases().then((res) => setCases(res.data)).catch(() => {});
//   const loadContent = () => adminGetContent().then((res) => setContent(res.data)).catch(() => {});
//   const loadMessages = () => adminGetMessages().then((res) => setMessages(res.data)).catch(() => {});
//   const loadAppointments = () => adminGetAppointments().then((res) => setAppointments(res.data)).catch(() => {});
//   const loadComplaints = () => adminGetComplaints().then((res) => setComplaints(res.data)).catch(() => {});
//   const loadVolunteers = () => adminGetVolunteers().then((res) => setVolunteers(res.data)).catch(() => {});

//   useEffect(() => {
//     loadMembers();
//     loadCases();
//     loadContent();
//     loadMessages();
//     loadAppointments();
//     loadComplaints();
//     loadVolunteers();
//   }, []);

//   const handleMemberStatusChange = async (id, status) => {
//     await adminUpdateMemberStatus(id, status);
//     loadMembers();
//   };

//   const handleRenew = async (id) => {
//     setRenewingId(id);
//     try {
//       await adminRenewMember(id);
//       loadMembers();
//     } catch (err) {
//       alert(err.response?.data?.message || 'Could not renew this membership.');
//     } finally {
//       setRenewingId(null);
//     }
//   };

//   const handleCaseStatusChange = async (id, status) => {
//     await adminUpdateCaseStatus(id, { status });
//     loadCases();
//   };

//   const handleContentSubmit = async (e) => {
//     e.preventDefault();
//     setSavingContent(true);
//     try {
//       if (editingId) {
//         await adminUpdateContent(editingId, contentForm);
//       } else {
//         await adminCreateContent(contentForm);
//       }
//       setContentForm(emptyContentForm);
//       setEditingId(null);
//       loadContent();
//     } finally {
//       setSavingContent(false);
//     }
//   };

//   const handleEditContent = (post) => {
//     setEditingId(post.id);
//     setContentForm({
//       title: post.title || '',
//       content: post.content || '',
//       category: post.category || 'NEWS',
//       mediaUrl: post.mediaUrl || '',
//     });
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const handleDeleteContent = async (id) => {
//     if (!window.confirm('Delete this post? This cannot be undone.')) return;
//     await adminDeleteContent(id);
//     if (editingId === id) {
//       setEditingId(null);
//       setContentForm(emptyContentForm);
//     }
//     loadContent();
//   };

//   const cancelEdit = () => {
//     setEditingId(null);
//     setContentForm(emptyContentForm);
//   };

//   // Build a de-duplicated list of members who have sent/received a message, for the reply dropdown
//   const membersWithMessages = Array.from(
//     new Map(messages.map((m) => [m.memberId, { id: m.memberId, name: m.memberFullName }])).values()
//   );

//   const handleSendReply = async (e) => {
//     e.preventDefault();
//     if (!replyMemberId || !replyContent.trim()) return;
//     setSendingReply(true);
//     try {
//       await adminReplyToMember(replyMemberId, replyContent);
//       setReplyContent('');
//       loadMessages();
//     } finally {
//       setSendingReply(false);
//     }
//   };

//   const handleAppointmentStatusChange = async (id, status) => {
//     await adminUpdateAppointmentStatus(id, status);
//     loadAppointments();
//   };

//   const handleComplaintStatusChange = async (id, status) => {
//     await adminUpdateComplaintStatus(id, status);
//     loadComplaints();
//   };

//   const handleVolunteerStatusChange = async (id, status) => {
//     await adminUpdateVolunteerStatus(id, status);
//     loadVolunteers();
//   };

//   const TABS = [
//     { key: 'members', label: 'Members' },
//     { key: 'cases', label: 'Cases' },
//     { key: 'messages', label: 'Messages' },
//     { key: 'appointments', label: 'Appointments' },
//     { key: 'complaints', label: 'Employer Complaints' },
//     { key: 'volunteers', label: 'Volunteers' },
//     { key: 'content', label: 'News & Podcast' },
//   ];

//   return (
//     <div className="dashboard-layout">
//       <aside className="dashboard-sidebar">
//         {TABS.map((t) => (
//   <button
//     key={t.key}
//     type="button"
//     className={tab === t.key ? 'active' : ''}
//     onClick={() => setTab(t.key)}
//   >
//     {t.label}
//   </button>
// ))}
//       </aside>

//       <div className="dashboard-main">
//         <h2 style={{ marginBottom: 24 }}>Administration Dashboard</h2>

//         {tab === 'members' && (
//           <div className="card" style={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
//                   <th style={th}>Membership #</th>
//                   <th style={th}>Full Name</th>
//                   <th style={th}>Province</th>
//                   <th style={th}>Expiry Date</th>
//                   <th style={th}>Status</th>
//                   <th style={th}>Update Status</th>
//                   <th style={th}>Renewal</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {members.map((m) => (
//                   <tr key={m.id} style={row}>
//                     <td style={td}>{m.membershipNumber}</td>
//                     <td style={td}>{m.fullName}</td>
//                     <td style={td}>{m.province}</td>
//                     <td style={td}>{m.expiryDate || '—'}</td>
//                     <td style={td}><span className="badge badge-pending">{m.status}</span></td>
//                     <td style={td}>
//                       <select defaultValue={m.status} onChange={(e) => handleMemberStatusChange(m.id, e.target.value)}>
//                         {MEMBER_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
//                       </select>
//                     </td>
//                     <td style={td}>
//                       <button
//                         className="btn btn-outline-dark"
//                         style={{ padding: '6px 14px' }}
//                         onClick={() => handleRenew(m.id)}
//                         disabled={renewingId === m.id}
//                       >
//                         {renewingId === m.id ? 'Renewing...' : 'Renew'}
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//                 {members.length === 0 && (
//                   <tr><td colSpan="7" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No members yet.</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {tab === 'cases' && (
//           <div className="card" style={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
//                   <th style={th}>Case #</th>
//                   <th style={th}>Title</th>
//                   <th style={th}>Member</th>
//                   <th style={th}>Status</th>
//                   <th style={th}>Update Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {cases.map((c) => (
//                   <tr key={c.id} style={row}>
//                     <td style={td}>{c.caseNumber}</td>
//                     <td style={td}>{c.title}</td>
//                     <td style={td}>{c.memberFullName}</td>
//                     <td style={td}><span className="badge badge-pending">{c.status.replace(/_/g, ' ')}</span></td>
//                     <td style={td}>
//                       <select defaultValue={c.status} onChange={(e) => handleCaseStatusChange(c.id, e.target.value)}>
//                         {CASE_STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}
//                       </select>
//                     </td>
//                   </tr>
//                 ))}
//                 {cases.length === 0 && (
//                   <tr><td colSpan="5" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No cases yet.</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {tab === 'messages' && (
//           <div>
//             <form onSubmit={handleSendReply} className="card" style={{ marginBottom: 24, maxWidth: 560 }}>
//               <h3>Reply to a Member</h3>
//               <div className="form-group">
//                 <label>Member</label>
//                 <select value={replyMemberId} onChange={(e) => setReplyMemberId(e.target.value)} required>
//                   <option value="">Select a member</option>
//                   {membersWithMessages.map((m) => (
//                     <option key={m.id} value={m.id}>{m.name}</option>
//                   ))}
//                 </select>
//               </div>
//               <div className="form-group">
//                 <label>Message</label>
//                 <textarea rows="3" value={replyContent} onChange={(e) => setReplyContent(e.target.value)} required />
//               </div>
//               <button className="btn btn-gold" disabled={sendingReply}>{sendingReply ? 'Sending...' : 'Send Reply'}</button>
//             </form>

//             <div className="card" style={{ overflowX: 'auto' }}>
//               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                 <thead>
//                   <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
//                     <th style={th}>Member</th>
//                     <th style={th}>From</th>
//                     <th style={th}>Message</th>
//                     <th style={th}>Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {messages.map((m) => (
//                     <tr key={m.id} style={row}>
//                       <td style={td}>{m.memberFullName}</td>
//                       <td style={td}>{m.sender === 'MEMBER' ? 'Member' : 'Organisation'}</td>
//                       <td style={td}>{m.content}</td>
//                       <td style={td}>{new Date(m.createdAt).toLocaleString()}</td>
//                     </tr>
//                   ))}
//                   {messages.length === 0 && (
//                     <tr><td colSpan="4" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No messages yet.</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {tab === 'appointments' && (
//           <div className="card" style={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
//                   <th style={th}>Member</th>
//                   <th style={th}>Type</th>
//                   <th style={th}>Requested Date/Time</th>
//                   <th style={th}>Notes</th>
//                   <th style={th}>Status</th>
//                   <th style={th}>Update Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {appointments.map((a) => (
//                   <tr key={a.id} style={row}>
//                     <td style={td}>{a.memberFullName}</td>
//                     <td style={td}>{a.type}</td>
//                     <td style={td}>{new Date(a.requestedDateTime).toLocaleString()}</td>
//                     <td style={td}>{a.notes || '—'}</td>
//                     <td style={td}><span className="badge badge-pending">{a.status}</span></td>
//                     <td style={td}>
//                       <select defaultValue={a.status} onChange={(e) => handleAppointmentStatusChange(a.id, e.target.value)}>
//                         {APPOINTMENT_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
//                       </select>
//                     </td>
//                   </tr>
//                 ))}
//                 {appointments.length === 0 && (
//                   <tr><td colSpan="6" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No appointments yet.</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {tab === 'complaints' && (
//           <div className="card" style={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
//                   <th style={th}>Complainant</th>
//                   <th style={th}>Contact</th>
//                   <th style={th}>Employer</th>
//                   <th style={th}>Description</th>
//                   <th style={th}>Status</th>
//                   <th style={th}>Update Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {complaints.map((c) => (
//                   <tr key={c.id} style={row}>
//                     <td style={td}>{c.complainantName}</td>
//                     <td style={td}>{c.complainantPhone}{c.complainantEmail ? ` / ${c.complainantEmail}` : ''}</td>
//                     <td style={td}>{c.employerName}</td>
//                     <td style={td} title={c.problemDescription}>
//                       {c.problemDescription?.length > 80 ? c.problemDescription.slice(0, 80) + '...' : c.problemDescription}
//                     </td>
//                     <td style={td}><span className="badge badge-pending">{c.status}</span></td>
//                     <td style={td}>
//                       <select defaultValue={c.status} onChange={(e) => handleComplaintStatusChange(c.id, e.target.value)}>
//                         {APPLICATION_STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}
//                       </select>
//                     </td>
//                   </tr>
//                 ))}
//                 {complaints.length === 0 && (
//                   <tr><td colSpan="6" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No complaints submitted yet.</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {tab === 'volunteers' && (
//           <div className="card" style={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
//                   <th style={th}>Name</th>
//                   <th style={th}>Contact</th>
//                   <th style={th}>Province</th>
//                   <th style={th}>Motivation</th>
//                   <th style={th}>Status</th>
//                   <th style={th}>Update Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {volunteers.map((v) => (
//                   <tr key={v.id} style={row}>
//                     <td style={td}>{v.fullName}</td>
//                     <td style={td}>{v.phoneNumber}{v.email ? ` / ${v.email}` : ''}</td>
//                     <td style={td}>{v.province}</td>
//                     <td style={td} title={v.motivation}>
//                       {v.motivation?.length > 80 ? v.motivation.slice(0, 80) + '...' : v.motivation}
//                     </td>
//                     <td style={td}><span className="badge badge-pending">{v.status}</span></td>
//                     <td style={td}>
//                       <select defaultValue={v.status} onChange={(e) => handleVolunteerStatusChange(v.id, e.target.value)}>
//                         {APPLICATION_STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}
//                       </select>
//                     </td>
//                   </tr>
//                 ))}
//                 {volunteers.length === 0 && (
//                   <tr><td colSpan="6" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No volunteer applications yet.</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {tab === 'content' && (
//           <div>
//             <div className="card" style={{ marginBottom: 24, maxWidth: 640 }}>
//               <h3>{editingId ? 'Edit Post' : 'Create New Post'}</h3>
//               <form onSubmit={handleContentSubmit}>
//                 <div className="form-group">
//                   <label>Category</label>
//                   <select
//                     value={contentForm.category}
//                     onChange={(e) => setContentForm({ ...contentForm, category: e.target.value })}
//                   >
//                     {CONTENT_CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Title</label>
//                   <input
//                     required
//                     value={contentForm.title}
//                     onChange={(e) => setContentForm({ ...contentForm, title: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Content / Description</label>
//                   <textarea
//                     rows="5"
//                     value={contentForm.content}
//                     onChange={(e) => setContentForm({ ...contentForm, content: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>YouTube / Video URL {contentForm.category === 'PODCAST' ? '' : '(optional)'}</label>
//                   <input
//                     type="url"
//                     placeholder="https://www.youtube.com/watch?v=..."
//                     required={contentForm.category === 'PODCAST'}
//                     value={contentForm.mediaUrl}
//                     onChange={(e) => setContentForm({ ...contentForm, mediaUrl: e.target.value })}
//                   />
//                 </div>
//                 <div style={{ display: 'flex', gap: 12 }}>
//                   <button className="btn btn-gold" disabled={savingContent}>
//                     {savingContent ? 'Saving...' : editingId ? 'Update Post' : 'Publish Post'}
//                   </button>
//                   {editingId && (
//                     <button type="button" className="btn btn-outline-dark" onClick={cancelEdit}>
//                       Cancel
//                     </button>
//                   )}
//                 </div>
//               </form>
//             </div>

//             <div className="card" style={{ overflowX: 'auto' }}>
//               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                 <thead>
//                   <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
//                     <th style={th}>Category</th>
//                     <th style={th}>Title</th>
//                     <th style={th}>Video</th>
//                     <th style={th}>Published</th>
//                     <th style={th}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {content.map((post) => (
//                     <tr key={post.id} style={row}>
//                       <td style={td}>
//                         <span className="badge badge-pending">{post.category.replace(/_/g, ' ')}</span>
//                       </td>
//                       <td style={td}>{post.title}</td>
//                       <td style={td}>
//                         {post.mediaUrl ? (
//                           <a href={post.mediaUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-gold)' }}>
//                             View
//                           </a>
//                         ) : '—'}
//                       </td>
//                       <td style={td}>{new Date(post.publishedAt).toLocaleDateString()}</td>
//                       <td style={{ ...td, display: 'flex', gap: 10 }}>
//                         <button className="btn btn-outline-dark" style={{ padding: '6px 14px' }} onClick={() => handleEditContent(post)}>
//                           Edit
//                         </button>
//                         <button
//                           className="btn"
//                           style={{ padding: '6px 14px', background: '#f8d9d9', color: '#a11f1f', clipPath: 'none' }}
//                           onClick={() => handleDeleteContent(post.id)}
//                         >
//                           Delete
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                   {content.length === 0 && (
//                     <tr><td colSpan="5" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No posts yet.</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from 'react';
import {
  adminGetMembers, adminGetCases, adminUpdateMemberStatus, adminUpdateCaseStatus, adminRenewMember,
  adminGetContent, adminCreateContent, adminUpdateContent, adminDeleteContent,
  adminGetMessages, adminReplyToMember,
  adminGetAppointments, adminUpdateAppointmentStatus,
  adminGetComplaints, adminUpdateComplaintStatus,
  adminGetVolunteers, adminUpdateVolunteerStatus,
  adminGetDocuments, adminUploadDocument, adminDownloadDocument,
} from '../../services/api';

const MEMBER_STATUSES = ['PENDING', 'ACTIVE', 'EXPIRED', 'SUSPENDED'];
const CASE_STATUSES = [
  'CASE_RECEIVED', 'CASE_REVIEW_COMPLETED', 'DOCUMENTS_PREPARED',
  'SUBMITTED', 'AWAITING_OUTCOME', 'FINALISED',
];
const APPOINTMENT_STATUSES = ['PENDING', 'CONFIRMED', 'CANCELLED', 'COMPLETED'];
const APPLICATION_STATUSES = ['SUBMITTED', 'UNDER_REVIEW', 'APPROVED', 'REJECTED'];
const CONTENT_CATEGORIES = [
  { value: 'NEWS', label: 'News & Announcements' },
  { value: 'PODCAST', label: 'Podcast Episode' },
  { value: 'RIGHTS_LIBRARY', label: "Rights Library Article" },
  { value: 'CASE_STORY', label: 'Real Case Story' },
];

const emptyContentForm = { title: '', content: '', category: 'NEWS', mediaUrl: '' };

const TABS = [
  { key: 'members', label: 'Members' },
  { key: 'cases', label: 'Cases' },
  { key: 'documents', label: 'Documents' },
  { key: 'messages', label: 'Messages' },
  { key: 'appointments', label: 'Appointments' },
  { key: 'complaints', label: 'Employer Complaints' },
  { key: 'volunteers', label: 'Volunteers' },
  { key: 'content', label: 'News & Podcast' },
];

export default function AdminDashboard() {
  const [tab, setTab] = useState('members');

  const [members, setMembers] = useState([]);
  const [cases, setCases] = useState([]);
  const [content, setContent] = useState([]);
  const [messages, setMessages] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [complaints, setComplaints] = useState([]);
  const [volunteers, setVolunteers] = useState([]);
  const [documents, setDocuments] = useState([]);

  const [contentForm, setContentForm] = useState(emptyContentForm);
  const [editingId, setEditingId] = useState(null);
  const [savingContent, setSavingContent] = useState(false);
  const [renewingId, setRenewingId] = useState(null);

  const [replyMemberId, setReplyMemberId] = useState('');
  const [replyText, setReplyText] = useState('');
  const [sendingReply, setSendingReply] = useState(false);

  const [uploadMemberId, setUploadMemberId] = useState('');
  const [uploadFile, setUploadFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [downloadingId, setDownloadingId] = useState(null);

  const loadMembers = () => adminGetMembers().then((res) => setMembers(res.data)).catch(() => {});
  const loadCases = () => adminGetCases().then((res) => setCases(res.data)).catch(() => {});
  const loadContent = () => adminGetContent().then((res) => setContent(res.data)).catch(() => {});
  const loadMessages = () => adminGetMessages().then((res) => setMessages(res.data)).catch(() => {});
  const loadAppointments = () => adminGetAppointments().then((res) => setAppointments(res.data)).catch(() => {});
  const loadComplaints = () => adminGetComplaints().then((res) => setComplaints(res.data)).catch(() => {});
  const loadVolunteers = () => adminGetVolunteers().then((res) => setVolunteers(res.data)).catch(() => {});
  const loadDocuments = () => adminGetDocuments().then((res) => setDocuments(res.data)).catch(() => {});

  useEffect(() => {
    loadMembers();
    loadCases();
    loadContent();
    loadMessages();
    loadAppointments();
    loadComplaints();
    loadVolunteers();
    loadDocuments();
  }, []);

  const handleMemberStatusChange = async (id, status) => {
    await adminUpdateMemberStatus(id, status);
    loadMembers();
  };

  const handleRenew = async (id) => {
    setRenewingId(id);
    try {
      await adminRenewMember(id);
      loadMembers();
    } catch (err) {
      alert(err.response?.data?.message || 'Could not renew this membership.');
    } finally {
      setRenewingId(null);
    }
  };

  const handleCaseStatusChange = async (id, status) => {
    await adminUpdateCaseStatus(id, { status });
    loadCases();
  };

  const handleContentSubmit = async (e) => {
    e.preventDefault();
    setSavingContent(true);
    try {
      if (editingId) {
        await adminUpdateContent(editingId, contentForm);
      } else {
        await adminCreateContent(contentForm);
      }
      setContentForm(emptyContentForm);
      setEditingId(null);
      loadContent();
    } finally {
      setSavingContent(false);
    }
  };

  const handleEditContent = (post) => {
    setEditingId(post.id);
    setContentForm({
      title: post.title || '',
      content: post.content || '',
      category: post.category || 'NEWS',
      mediaUrl: post.mediaUrl || '',
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDeleteContent = async (id) => {
    if (!window.confirm('Delete this post? This cannot be undone.')) return;
    await adminDeleteContent(id);
    if (editingId === id) {
      setEditingId(null);
      setContentForm(emptyContentForm);
    }
    loadContent();
  };

  const cancelEdit = () => {
    setEditingId(null);
    setContentForm(emptyContentForm);
  };

  const handleReplySubmit = async (e) => {
    e.preventDefault();
    if (!replyMemberId || !replyText.trim()) return;
    setSendingReply(true);
    try {
      await adminReplyToMember(replyMemberId, replyText);
      setReplyText('');
      loadMessages();
    } finally {
      setSendingReply(false);
    }
  };

  const handleAppointmentStatusChange = async (id, status) => {
    await adminUpdateAppointmentStatus(id, status);
    loadAppointments();
  };

  const handleComplaintStatusChange = async (id, status) => {
    await adminUpdateComplaintStatus(id, status);
    loadComplaints();
  };

  const handleVolunteerStatusChange = async (id, status) => {
    await adminUpdateVolunteerStatus(id, status);
    loadVolunteers();
  };

  const handleDocumentUpload = async (e) => {
    e.preventDefault();
    if (!uploadMemberId || !uploadFile) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', uploadFile);
      await adminUploadDocument(uploadMemberId, formData);
      setUploadFile(null);
      setUploadMemberId('');
      loadDocuments();
    } catch (err) {
      alert(err.response?.data?.message || 'Upload failed.');
    } finally {
      setUploading(false);
    }
  };

  const handleDownload = async (doc) => {
    setDownloadingId(doc.id);
    try {
      const res = await adminDownloadDocument(doc.id);
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', doc.fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Could not download this file.');
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <div className="dashboard-layout">
      <aside className="dashboard-sidebar">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={tab === t.key ? 'active' : ''}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </aside>

      <div className="dashboard-main">
        <h2 style={{ marginBottom: 24 }}>Administration Dashboard</h2>

        {tab === 'members' && (
          <div className="card" style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                  <th style={{ padding: 10 }}>Membership #</th>
                  <th style={{ padding: 10 }}>Full Name</th>
                  <th style={{ padding: 10 }}>Province</th>
                  <th style={{ padding: 10 }}>Expiry Date</th>
                  <th style={{ padding: 10 }}>Status</th>
                  <th style={{ padding: 10 }}>Update Status</th>
                  <th style={{ padding: 10 }}>Renewal</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 10 }}>{m.membershipNumber}</td>
                    <td style={{ padding: 10 }}>{m.fullName}</td>
                    <td style={{ padding: 10 }}>{m.province}</td>
                    <td style={{ padding: 10 }}>{m.expiryDate || '—'}</td>
                    <td style={{ padding: 10 }}><span className="badge badge-pending">{m.status}</span></td>
                    <td style={{ padding: 10 }}>
                      <select defaultValue={m.status} onChange={(e) => handleMemberStatusChange(m.id, e.target.value)}>
                        {MEMBER_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td>
                    <td style={{ padding: 10 }}>
                      <button
                        className="btn btn-outline-dark"
                        style={{ padding: '6px 14px' }}
                        onClick={() => handleRenew(m.id)}
                        disabled={renewingId === m.id}
                      >
                        {renewingId === m.id ? 'Renewing...' : 'Renew'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {tab === 'cases' && (
          <div className="card" style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                  <th style={{ padding: 10 }}>Case #</th>
                  <th style={{ padding: 10 }}>Title</th>
                  <th style={{ padding: 10 }}>Member</th>
                  <th style={{ padding: 10 }}>Status</th>
                  <th style={{ padding: 10 }}>Update Status</th>
                </tr>
              </thead>
              <tbody>
                {cases.map((c) => (
                  <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 10 }}>{c.caseNumber}</td>
                    <td style={{ padding: 10 }}>{c.title}</td>
                    <td style={{ padding: 10 }}>{c.memberFullName}</td>
                    <td style={{ padding: 10 }}><span className="badge badge-pending">{c.status.replace(/_/g, ' ')}</span></td>
                    <td style={{ padding: 10 }}>
                      <select defaultValue={c.status} onChange={(e) => handleCaseStatusChange(c.id, e.target.value)}>
                        {CASE_STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {tab === 'documents' && (
          <div>
            <div className="card" style={{ marginBottom: 24, maxWidth: 560 }}>
              <h3>Upload a Document for a Member</h3>
              <p style={{ fontSize: '0.85rem', color: 'var(--color-grey)', marginBottom: 16 }}>
                Use this to send a member a completed document — a finalised letter,
                CCMA form, or other paperwork prepared on their behalf.
              </p>
              <form onSubmit={handleDocumentUpload}>
                <div className="form-group">
                  <label>Member</label>
                  <select required value={uploadMemberId} onChange={(e) => setUploadMemberId(e.target.value)}>
                    <option value="">Select a member</option>
                    {members.map((m) => (
                      <option key={m.id} value={m.id}>{m.fullName} ({m.membershipNumber})</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>File</label>
                  <input type="file" required onChange={(e) => setUploadFile(e.target.files[0])} />
                </div>
                <button className="btn btn-gold" disabled={uploading}>
                  {uploading ? 'Uploading...' : 'Upload Document'}
                </button>
              </form>
            </div>

            <div className="card" style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                    <th style={{ padding: 10 }}>Member</th>
                    <th style={{ padding: 10 }}>File</th>
                    <th style={{ padding: 10 }}>Case</th>
                    <th style={{ padding: 10 }}>Uploaded By</th>
                    <th style={{ padding: 10 }}>Date</th>
                    <th style={{ padding: 10 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {documents.map((d) => (
                    <tr key={d.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: 10 }}>{d.memberFullName} ({d.membershipNumber})</td>
                      <td style={{ padding: 10 }}>{d.fileName}</td>
                      <td style={{ padding: 10 }}>{d.caseNumber || '—'}</td>
                      <td style={{ padding: 10 }}>
                        <span className="badge badge-pending">{d.uploadedBy === 'MEMBER' ? 'Member' : 'Organisation'}</span>
                      </td>
                      <td style={{ padding: 10 }}>{new Date(d.uploadedAt).toLocaleDateString()}</td>
                      <td style={{ padding: 10 }}>
                        <button
                          className="btn btn-outline-dark"
                          style={{ padding: '6px 14px' }}
                          onClick={() => handleDownload(d)}
                          disabled={downloadingId === d.id}
                        >
                          {downloadingId === d.id ? 'Downloading...' : 'Download'}
                        </button>
                      </td>
                    </tr>
                  ))}
                  {documents.length === 0 && (
                    <tr><td colSpan="6" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No documents uploaded yet.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {tab === 'messages' && (
          <div>
            <div className="card" style={{ marginBottom: 24, maxWidth: 560 }}>
              <h3>Reply to a Member</h3>
              <form onSubmit={handleReplySubmit}>
                <div className="form-group">
                  <label>Member</label>
                  <select required value={replyMemberId} onChange={(e) => setReplyMemberId(e.target.value)}>
                    <option value="">Select a member</option>
                    {members.map((m) => (
                      <option key={m.id} value={m.id}>{m.fullName} ({m.membershipNumber})</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea rows="3" required value={replyText} onChange={(e) => setReplyText(e.target.value)} />
                </div>
                <button className="btn btn-gold" disabled={sendingReply}>
                  {sendingReply ? 'Sending...' : 'Send Reply'}
                </button>
              </form>
            </div>

            <div className="card" style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                    <th style={{ padding: 10 }}>From</th>
                    <th style={{ padding: 10 }}>Message</th>
                    <th style={{ padding: 10 }}>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {messages.map((msg) => (
                    <tr key={msg.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: 10 }}>
                        {msg.sender === 'MEMBER' ? `${msg.memberFullName} (${msg.membershipNumber})` : 'You (Organisation)'}
                      </td>
                      <td style={{ padding: 10 }}>{msg.content}</td>
                      <td style={{ padding: 10 }}>{new Date(msg.createdAt).toLocaleString()}</td>
                    </tr>
                  ))}
                  {messages.length === 0 && (
                    <tr><td colSpan="3" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No messages yet.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {tab === 'appointments' && (
          <div className="card" style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                  <th style={{ padding: 10 }}>Member</th>
                  <th style={{ padding: 10 }}>Type</th>
                  <th style={{ padding: 10 }}>Date/Time</th>
                  <th style={{ padding: 10 }}>Status</th>
                  <th style={{ padding: 10 }}>Update Status</th>
                </tr>
              </thead>
              <tbody>
                {appointments.map((a) => (
                  <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 10 }}>{a.memberFullName} ({a.membershipNumber})</td>
                    <td style={{ padding: 10 }}>{a.type}</td>
                    <td style={{ padding: 10 }}>{new Date(a.requestedDateTime).toLocaleString()}</td>
                    <td style={{ padding: 10 }}><span className="badge badge-pending">{a.status}</span></td>
                    <td style={{ padding: 10 }}>
                      <select defaultValue={a.status} onChange={(e) => handleAppointmentStatusChange(a.id, e.target.value)}>
                        {APPOINTMENT_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td>
                  </tr>
                ))}
                {appointments.length === 0 && (
                  <tr><td colSpan="5" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No appointments booked yet.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {tab === 'complaints' && (
          <div className="card" style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                  <th style={{ padding: 10 }}>Name</th>
                  <th style={{ padding: 10 }}>Employer</th>
                  <th style={{ padding: 10 }}>Description</th>
                  <th style={{ padding: 10 }}>Status</th>
                  <th style={{ padding: 10 }}>Update Status</th>
                </tr>
              </thead>
              <tbody>
                {complaints.map((c) => (
                  <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 10 }}>{c.complainantName}<br /><span style={{ fontSize: '0.8rem', color: 'var(--color-grey)' }}>{c.complainantPhone}</span></td>
                    <td style={{ padding: 10 }}>{c.employerName}</td>
                    <td style={{ padding: 10, maxWidth: 300 }}>{c.problemDescription}</td>
                    <td style={{ padding: 10 }}><span className="badge badge-pending">{c.status}</span></td>
                    <td style={{ padding: 10 }}>
                      <select defaultValue={c.status} onChange={(e) => handleComplaintStatusChange(c.id, e.target.value)}>
                        {APPLICATION_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td>
                  </tr>
                ))}
                {complaints.length === 0 && (
                  <tr><td colSpan="5" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No complaints submitted yet.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {tab === 'volunteers' && (
          <div className="card" style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                  <th style={{ padding: 10 }}>Name</th>
                  <th style={{ padding: 10 }}>Province</th>
                  <th style={{ padding: 10 }}>Contact</th>
                  <th style={{ padding: 10 }}>Status</th>
                  <th style={{ padding: 10 }}>Update Status</th>
                </tr>
              </thead>
              <tbody>
                {volunteers.map((v) => (
                  <tr key={v.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 10 }}>{v.fullName}</td>
                    <td style={{ padding: 10 }}>{v.province}</td>
                    <td style={{ padding: 10 }}>{v.email}<br /><span style={{ fontSize: '0.8rem', color: 'var(--color-grey)' }}>{v.phoneNumber}</span></td>
                    <td style={{ padding: 10 }}><span className="badge badge-pending">{v.status}</span></td>
                    <td style={{ padding: 10 }}>
                      <select defaultValue={v.status} onChange={(e) => handleVolunteerStatusChange(v.id, e.target.value)}>
                        {APPLICATION_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td>
                  </tr>
                ))}
                {volunteers.length === 0 && (
                  <tr><td colSpan="5" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No volunteer applications yet.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {tab === 'content' && (
          <div>
            <div className="card" style={{ marginBottom: 24, maxWidth: 640 }}>
              <h3>{editingId ? 'Edit Post' : 'Create New Post'}</h3>
              <form onSubmit={handleContentSubmit}>
                <div className="form-group">
                  <label>Category</label>
                  <select
                    value={contentForm.category}
                    onChange={(e) => setContentForm({ ...contentForm, category: e.target.value })}
                  >
                    {CONTENT_CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Title</label>
                  <input
                    required
                    value={contentForm.title}
                    onChange={(e) => setContentForm({ ...contentForm, title: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Content / Description</label>
                  <textarea
                    rows="5"
                    value={contentForm.content}
                    onChange={(e) => setContentForm({ ...contentForm, content: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>YouTube / Video URL {contentForm.category === 'PODCAST' ? '' : '(optional)'}</label>
                  <input
                    type="url"
                    placeholder="https://www.youtube.com/watch?v=..."
                    required={contentForm.category === 'PODCAST'}
                    value={contentForm.mediaUrl}
                    onChange={(e) => setContentForm({ ...contentForm, mediaUrl: e.target.value })}
                  />
                </div>
                <div style={{ display: 'flex', gap: 12 }}>
                  <button className="btn btn-gold" disabled={savingContent}>
                    {savingContent ? 'Saving...' : editingId ? 'Update Post' : 'Publish Post'}
                  </button>
                  {editingId && (
                    <button type="button" className="btn btn-outline-dark" onClick={cancelEdit}>
                      Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>

            <div className="card" style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                    <th style={{ padding: 10 }}>Category</th>
                    <th style={{ padding: 10 }}>Title</th>
                    <th style={{ padding: 10 }}>Video</th>
                    <th style={{ padding: 10 }}>Published</th>
                    <th style={{ padding: 10 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {content.map((post) => (
                    <tr key={post.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: 10 }}>
                        <span className="badge badge-pending">{post.category.replace(/_/g, ' ')}</span>
                      </td>
                      <td style={{ padding: 10 }}>{post.title}</td>
                      <td style={{ padding: 10 }}>
                        {post.mediaUrl ? (
                          <a href={post.mediaUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-gold)' }}>
                            View
                          </a>
                        ) : '—'}
                      </td>
                      <td style={{ padding: 10 }}>{new Date(post.publishedAt).toLocaleDateString()}</td>
                      <td style={{ padding: 10, display: 'flex', gap: 10 }}>
                        <button className="btn btn-outline-dark" style={{ padding: '6px 14px' }} onClick={() => handleEditContent(post)}>
                          Edit
                        </button>
                        <button
                          className="btn"
                          style={{ padding: '6px 14px', background: '#f8d9d9', color: '#a11f1f', clipPath: 'none' }}
                          onClick={() => handleDeleteContent(post.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                  {content.length === 0 && (
                    <tr><td colSpan="5" style={{ padding: 16, textAlign: 'center', color: 'var(--color-grey)' }}>No posts yet.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
